import { render, staticRenderFns } from "./LieferfaehigkeitEntwicklungView.vue?vue&type=template&id=2cf3cdf3&"
import script from "./LieferfaehigkeitEntwicklungView.vue?vue&type=script&lang=js&"
export * from "./LieferfaehigkeitEntwicklungView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports